import {BaseModel} from "../base";

class AnswerModel extends BaseModel {
    constructor(data) {
        super(data);
    }

    /**
     * @description
     * Build an array of questions
     *
     * @returns {Promise} A promise for the question/s
     */
    getQuestion() {
        return new Promise((resolve, reject) => {
            if (this.question) {
                resolve(this.question);
            }
            if (this._data.$has('question')) {
                this._data.$get('question').then((question) => {
                        this.question = question;
                        return resolve(this.question);
                    }
                );
            } else {
                resolve([]);
            }
        });
    }
}

export {
    AnswerModel
}